import { Campaign, CampaignTypes } from '@/models';
import { SideQuest } from '@/models/leaderboard';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgLeaderboardSideQuest',
})
export default class CmgLeaderboardSideQuest extends Vue {
  isSubmitted: boolean = false;

  @Prop({ required: true, type: Object })
  sideQuest!: SideQuest;

  get extraPoints(): string {
    return this.sideQuest.extraPoints > 0
      ? `${this.sideQuest.extraPoints} PTS`
      : '';
  }

  get titleText(): string {
    return this.sideQuest.title.toUpperCase();
  }

  get isActivated(): boolean {
    return this.sideQuest.isOptedIn;
  }

  get checkMarkUrl(): string {
    return this.$appStore.state.cms.images.icons.activatedCheckmark.default;
  }

  get mediaImageUrl(): string {
    return this.sideQuest.isOptedIn
      ? this.sideQuest.mediaUri
      : this.sideQuest.mediaUriInactive;
  }

  get endDateText(): string {
    if (!this.sideQuest.endDate) return '';
    const date = new Date(this.sideQuest.endDate);
    return `Offer ends ${date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}`;
  }

  get sideQuestBorderUrl(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardWhiteBoxPinkYellowBorder.default;
  }

  onClickCard(): void {
      const campaign = this.sideQuest as Campaign;
      campaign.campaignType = CampaignTypes.OptIn;
      this.$services.ui.setModalVisibility('rewardExtrasCampaignDetail', true, { campaign });
      Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
  }
}
